// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5de71787","453":"ee131c13","732":"c7e0a35f","977":"79111d23"}[chunkId] + ".chunk.js";
};